/** Title for surfaces outside the app's own chrome, such as tray notifications. */
export const APP_NAME = 'Shlonak';

// The logos shipped with the app. Resetting the theme re-uploads these so the
// customer ends up with stored files rather than an empty brand.
export const DEFAULT_BRAND_LOGOS = {
  desktop: 'assets/brand/shlonak-light.png',
  mobile: 'assets/brand/shlonak-icon.png',
};

// Uploads are stored as `<id>_<original name>`, so recognising a default logo
// means comparing against these basenames. Derived so they cannot drift.
export const DEFAULT_BRAND_LOGO_NAMES = {
  desktop: DEFAULT_BRAND_LOGOS.desktop.split('/').pop(),
  mobile: DEFAULT_BRAND_LOGOS.mobile.split('/').pop(),
};

/** Preset the theme falls back to, and the one "reset to default" restores. */
export const DEFAULT_PALETTE_NAME = 'blue';
